"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Toolbar_1 = require("@material-ui/core/Toolbar");

var React = require("react");

var uno_react_1 = require("uno-react");

var SearchTextInput_1 = require("../Filtering/SearchTextInput");

var ExportButton_1 = require("./ExportButton");

var styles = {
  mobileSpacer: {
    flexShrink: '1'
  },
  spacer: {
    flex: '1 1 45%'
  }
};
var outerWidth = 800;
var timeout = 400;

exports.GridToolbar = function (_a) {
  var toolbarOptions = _a.toolbarOptions,
      gridName = _a.gridName,
      grid = _a.grid;
  var isMobileResolution = uno_react_1.useResolutionSwitch(outerWidth, timeout)[0];
  return React.createElement(Toolbar_1["default"], {
    "data-testid": 'grid-toolbar'
  }, React.createElement("div", {
    style: isMobileResolution ? styles.mobileSpacer : styles.spacer
  }), toolbarOptions.customItems && toolbarOptions.customItems, toolbarOptions.exportButton && React.createElement(ExportButton_1.ExportButton, {
    type: 'csv',
    gridName: gridName,
    exportTo: grid.api.exportTo,
    filteredRecordCount: grid.state.filteredRecordCount,
    "data-testid": 'export-button-csv'
  }), toolbarOptions.printButton && React.createElement(ExportButton_1.ExportButton, {
    type: 'print',
    gridName: gridName,
    exportTo: grid.api.exportTo,
    filteredRecordCount: grid.state.filteredRecordCount,
    "data-testid": 'export-button-print'
  }), toolbarOptions.searchText && React.createElement(SearchTextInput_1.SearchTextInput, {
    searchText: grid.state.searchText,
    updateSearchText: grid.api.updateSearchText,
    "data-testid": 'search-text-input'
  }));
};